import { IIDAndName } from '../models/Entity';
import { SelectOptions } from 'oneplace-components';

export function mapIDAndNameOptions(options: IIDAndName[]): SelectOptions {
    const newOptions: SelectOptions = [];
    options.forEach((option) => {
        newOptions.push({value: String(option.id), label: option.name});
    });
    return newOptions;
}

export function isNumber(numberValue: string) {
    return (numberValue != null) && !isNaN(Number(numberValue));
}

export const isEmail = (email: string) => !isBlank(email) &&  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isNullOrUndefined = (value: any) => value === null || value === undefined;

export const isBlank = (value: string) => isNullOrUndefined(value) || value.trim().length === 0;

export const getErrorMessage = (e: unknown): string =>
    e instanceof Error ? e.message : typeof e === 'string' ? e : '';

export const emailToBase64 = (email: string): string|null => {
    if (!isEmail(email))
        return null;

    const bytes = new TextEncoder().encode(email.trim());

    let binaryString = "";
    for (let i = 0; i < bytes.length; i++) {
        binaryString += String.fromCharCode(bytes[i]);
    }

    const base64 = btoa(binaryString);

    return base64
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};